import { atom } from "jotai";
import {
  ServiceDefaultData,
  ServiceCustomData,
} from "./types";

// Default API data (20 newest)
export const defaultServicesAtom = atom<ServiceDefaultData>({
  components: [],
});

// Per-part custom API data (by IDs) - supports multiple parts with different custom data
export const partCustomServicesAtom = atom<
  Record<string, ServiceCustomData>
>({});
